<template>
	<div v-if="ready"><slot /></div>
</template>

<script>
import Vue from 'vue'
import _ from 'lodash'
import Cookies from 'js-cookie'
import {locales} from '../config/i18n'
import {switchDocumentLocale} from '../services/i18n/util'
import {setUiLocale, t} from '../services/i18n'

export default {
	data() {
		return {
			ready: false,
		}
	},

	methods: {
		set(locale) {
			this.ready = false
			Cookies.set('_al', locale)
			window.locale = locale
			var dic = window.DICTIONARY || {}
			setUiLocale(locale)
				.then(() => {
					Vue.prototype.$t = Vue.prototype.trans = (key, /*eg:(.)*/ suffix = '') => {
						if (key) {
							var keyProc = key.slice().trim()
							keyProc = keyProc.toLocaleLowerCase().replace(new RegExp(' ', 'g'), '_')
							keyProc = keyProc.replace(new RegExp('[0-9]', 'g'), '')
							keyProc = keyProc.replace('.', '')
							var value = t(keyProc)
							if (keyProc === value) {
								dic[keyProc] = key.replace(new RegExp('_', 'g'), ' ')
							}
							// console.log(JSON.stringify(dic, null, 2))
							if (value.length) {
								return value + suffix
							}
						}

						return key + suffix
					}
					this.ready = true
					const dir = _.find(locales, (l) => l.code === locale).dir
					switchDocumentLocale(locale, dir, {
						withRTL: ['static/styles/rtl.css'],
					})
				})
				/* eslint-disable no-console */
				.catch((err) => {
					console.log(err)
				})
		},
	},

	mounted() {
		this.set(this.$root.locale)
	},

	watch: {
		/* eslint-disable object-shorthand */
		$route(to) {
			this.set(Cookies.get('_al') || 'en')
		},
		'$root.locale'(locale) {
			this.set(locale)
		},
	},
}
</script>
